import React, {
    useCallback,
    useEffect,
    useState
} from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";

import {
    Wrapper,
    FileInputWrapper,
    Label,
    Placeholder
} from "./styled.js";
import { fileUpload } from "./service";
import Loader from "../UpkeepLoaderTripleGear";

export const FileInput = ({ label, placeholder, required, accept,
                              onChange, ...props }) => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const onDrop = useCallback(acceptedFiles => {
        setLoading(true);
        const reader = new FileReader();
        reader.onload = console.debug;
        reader.onabort = console.warn;
        reader.onerror = console.error;

        acceptedFiles.forEach(file => reader.readAsBinaryString(file));
        const fileUploadPromises = acceptedFiles.map(file => fileUpload('', file)
            .then(res => file._upload = res));
        Promise.all(fileUploadPromises)
            .then(() => setFiles([...acceptedFiles]))
            .then(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (onChange) {
            // share the actual value after upload the image
            // instead of the file object by the browser
            onChange(files.map(f => f._upload));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    const {
        getRootProps,
        getInputProps,
        isDragActive
    } = useDropzone({
        onDrop,
        accept,
        multiple: false,
    });

    const rootProps = getRootProps();
    const inputProps = getInputProps();

    // override placeholder if files are selected
    if (files.length !== 0) {
        const fileNames = files.map(f => f.name);
        placeholder = fileNames.join(', ');
    }

    return <Wrapper {...rootProps}>
        <input {...inputProps} required={required}/>
        {label && <Label required={required}>{label}</Label>}
        <FileInputWrapper
            className={`file-input ${isDragActive ? 'active' : 'inactive'}`}
            required={required}
        >
            { !loading && props.children }
            { !loading && <Placeholder>{placeholder}</Placeholder> }
            { loading && <Loader/> }
        </FileInputWrapper>
    </Wrapper>
};

FileInput.propTypes = {
    placeholder: PropTypes.string.isRequired,
    accept: PropTypes.string
};

FileInput.defaultProps = {
    placeholder: 'Drop the file here to upload...',
    accept: 'image/*'
};

export default FileInput;
